import { useEffect, useLayoutEffect, useRef } from "react";
import { OverlayComponent, OverlayPosition } from "shared/components/overlay";

import styles from './YandexSearchModal.module.scss';

declare const Ya: any;

export interface YandexSearchModalProps {
	onHideRequest: () => void;
}

export const YandexSearchModalComponent = (props: YandexSearchModalProps) => {
	useLayoutEffect(() => {
		Ya.Site.Form.init();
	}, []);

	return (
		<OverlayComponent position={OverlayPosition.Fill} dropShadow={true} onShadowClick={props.onHideRequest}>
			<div className={styles.container}>
			<div className="ya-site-form ya-site-form_inited_no"
				data-bem="{&quot;action&quot;:&quot;https://yandex.ru/search/site/&quot;,&quot;arrow&quot;:false,&quot;bg&quot;:&quot;transparent&quot;,&quot;fontsize&quot;:25,&quot;fg&quot;:&quot;#000000&quot;,&quot;language&quot;:&quot;ru&quot;,&quot;logo&quot;:&quot;rb&quot;,&quot;publicname&quot;:&quot;Поиск на базе RUSETFs&quot;,&quot;suggest&quot;:true,&quot;target&quot;:&quot;_blank&quot;,&quot;tld&quot;:&quot;ru&quot;,&quot;type&quot;:2,&quot;usebigdictionary&quot;:true,&quot;searchid&quot;:2384588,&quot;input_fg&quot;:&quot;#000000&quot;,&quot;input_bg&quot;:&quot;#ffffff&quot;,&quot;input_fontStyle&quot;:&quot;normal&quot;,&quot;input_fontWeight&quot;:&quot;normal&quot;,&quot;input_placeholder&quot;:&quot;&quot;,&quot;input_placeholderColor&quot;:&quot;#000000&quot;,&quot;input_borderColor&quot;:&quot;#454d55&quot;}">
				<form className="ya-site-form ya-site-form_inited_no" action="https://yandex.ru/search/site/" method="get" target="_blank" acceptCharset="utf-8">
					<input type="hidden" name="searchid" value="2384588" />
					<input type="hidden" name="l10n" value="ru" />
					<input type="hidden" name="reqenc" value="" />
					<input type="search" name="text" defaultValue="" />
					<button type="submit">Найти</button>
				</form>
				</div>
			</div>
		</OverlayComponent>
	);
}
